export const PUBLIC_EXACT_PATHS = [
  '/politica-de-privacidade',
  '/privacidade-ia-whatsapp',
  '/ia-assistente-whatsapp',
] as const;

export const PUBLIC_PATH_PREFIXES = [
  '/register',
  '/cadastro',
] as const;

function stripTrailingSlash(pathname: string): string {
  return pathname !== '/' && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;
}

export function isPublicRoute(pathname: string): boolean {
  const normalizedPathname = stripTrailingSlash(pathname);

  if ((PUBLIC_EXACT_PATHS as readonly string[]).includes(normalizedPathname)) {
    return true;
  }

  return PUBLIC_PATH_PREFIXES.some(
    prefix =>
      normalizedPathname === prefix ||
      normalizedPathname.startsWith(`${prefix}/`),
  );
}
